import { useMutation, useQueryClient } from "react-query";
import { deleteAdvertisement } from "api/services/advertisements";
import { EAdvertisementsQueryKeys } from "api/endpoints/advertisements";
import { logError } from "utils/notifications";
import { TApiError } from "types/api/error";
import { TUrlParam } from "types/utils";

export const useDeleteAdvertisement = () => {
  const queryClient = useQueryClient();
  return useMutation<void, TApiError, TUrlParam>(
    [EAdvertisementsQueryKeys.deleteAdvertisement],
    deleteAdvertisement,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(
          EAdvertisementsQueryKeys.getAdvertisements
        );
        queryClient.invalidateQueries(
          EAdvertisementsQueryKeys.getAdminAdvertisements
        );
      },
      onError: (error) => logError({ error }),
      retry: false,
    }
  );
};
